import { computed, Injectable, signal } from '@angular/core';

import { MenuItem } from '../../shared/models/side-menu.model';
import { ResponseData } from '@shared/helpers/response-data';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})

export class MenuStateService {
  #menuItems = signal<ResponseData<MenuItem[]>>({
    data: null,
    status: 'loading'
  });
  readonly menuItems$ = toObservable(this.#menuItems);

  readonly menuLoaded = computed(() => this.#menuItems().status !== 'loading');
  readonly menuLoaded$ = toObservable(this.menuLoaded);

  #isMenuOpen = signal(false);
  readonly isMenuOpen$ = toObservable(this.#isMenuOpen);

  setMenuItems(value: ResponseData<MenuItem[]>): void {
    this.#menuItems.set(value);
  }

  getMenuStatus(): ResponseData<MenuItem[]>['status'] {
    return this.#menuItems().status;
  }

  toggleMenu(): void {
    this.#isMenuOpen.update(current => !current);
    document.body.classList.toggle('expand-side-menu');
  }

  setMenuState(isOpen: boolean): void {
    this.#isMenuOpen.set(isOpen);
  }

  reset(): void {
    this.#menuItems.set({ data: null, status: 'loading' });
    this.#isMenuOpen.set(false);
    document.body.classList.remove('expand-side-menu');
  }
}
